import React, { useState} from "react";
import { Card } from "antd";
import { Send, Sparkles, Trophy } from "lucide-react";



const AwardStatusCard = (props) => {
  const {} = props;

  const awardStatus =
  [  
    {
      id: 1,
      title: "My Nominations (Month)",
      icon: Send,
      count: 3,
      color: "emerald-white",
    },
    {
      id: 2,
      title: "Pending Reviews",
      icon: Sparkles,
      count: 3,
      color: "purple-white",
    },
    {
      id: 3,
      title: "Total Awards (Month)",
      icon: Trophy,
      count: 3,
      color: "amber-white",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {awardStatus.map((item) => {
        const Icon = item.icon;
        return(
          <Card
          key={item.id}
          className={`rounded-xl card-border-s ${item.color}`}
        >
          <div className="flex items-center justify-between"> 
            <div>
              <p class="text-[12px] text-muted-foreground mb-1">{item.title}</p>
              <p class="text-[24px] font-semibold card-text">{item.count}</p>
            </div>
            <div className="icon-theme p-3 rounded-xl">
              <Icon className="w-6 h-6" />
            </div>
          </div>
        </Card>   
        );
      })}
    </div>
  );
};

export default AwardStatusCard;
